﻿export const getUserWhoApprovedStep = (
  usersWhoApprovedSteps,
  historyOfApprovals,
  approvalStepId
) =>
  usersWhoApprovedSteps?.find(({ id: userId }) => {
    if (!historyOfApprovals || !userId) return false;

    const setBy = historyOfApprovals.find(
      ({ workflowStepId }) => workflowStepId === approvalStepId
    )?.setBy;

    if (!setBy) return false;

    return userId === setBy;
  });
